import React from 'react';
import classNames from 'classnames';
import get from 'lodash.get';

import { widget as widgetPropType } from 'lib/CustomPropTypes';
import loadScript from 'lib/loadScript';
import { decodeString } from 'lib/stringUtils';
import getAllRegexMatches from 'lib/getAllRegexMatches';

import MenuEmbed from './MenuEmbed/index';

import styles from '../styles.module.scss';

export default class AdvancedEmbed extends React.Component {
  scriptTagRegex = /<script[^>]+?src="([^"]+?)"[^>]*?><\/script>/gi;

  scriptsWithoutSrcs = /<script>([^]+?)<\/script>/gi;

  static propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    widget: widgetPropType.isRequired,
  };

  /*
  THIS IS A HUGE VULERNABILLITY!!!
  */
  componentDidMount() {
    const html = decodeString(get(this.props, 'widget.properties[\'embed-code\']', ''));

    // embed-code not found or not valid
    if (html && typeof html === 'string') {
      const externalScripts = getAllRegexMatches(this.scriptTagRegex, html)
        .map(([/* ignore first element */, scriptSrc]) => loadScript(
          scriptSrc,
          {
            location: this.containerElem || 'head',
            attributes: { defer: true },
            force: true,
          },
        ));

      Promise.all(externalScripts)
        .then(() => {
          const domFragment = document.createDocumentFragment();

          getAllRegexMatches(this.scriptsWithoutSrcs, html)
            .forEach(([, scriptContent]) => { // ignore first index of array
              const scriptTag = document.createElement('script');
              scriptTag.innerHTML = scriptContent;
              domFragment.appendChild(scriptTag);
            });

          this.containerElem.appendChild(domFragment);
        });
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    let html = decodeString(get(this.props, 'widget.properties[\'embed-code\']', ''));

    // embed-code not found or not valid
    if (!html || typeof html !== 'string') {
      return null;
    }

    if (html.match(/class=["“”]menu-embed["“”]/) && html.match(/embedId=["“”][0-9]+["“”]/)) {
      return <MenuEmbed className="menu-embed" html={html} />;
    }

    if (/^https?:\/\/nodeassets.nbcnews/.test(html)) {
      return <iframe width="100%" height="500px" src={html} title="embed" />;
    }

    if (/vimeo.com/.test(html)) {
      html = html.replace(/\s*(width|height)=["']([^"]+)["']/g, '');
      return (
        <div className={classNames(styles.usePresentation, styles.vimeo)}>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: decodeString(html) }}
          />
        </div>
      );
    }

    // Strip script tag from markup
    html = html.replace(this.scriptTagRegex, '').replace(this.scriptsWithoutSrcs, '');

    return (
      <div
        className={styles.usePresentation}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: decodeString(html) }}
        ref={(elem) => { this.containerElem = elem; }}
      />
    );
  }
}
